// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import getColor from "@insite/mobius/utilities/getColor";
import { ellipsis } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

export const plpSelectStyle = {
    ...sortSelectStyles.select,
    mobiusMode: true,
    labelProps: {
        css: css`
            width: auto;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 17px;
            padding-top: 0;
            display: flex;
            align-items: center;
        `,
    },
    cssOverrides: {
        formField: css`
            width: 270px;

            div[class^="IconWrapper"] {
                display: flex;
                justify-content: center;
            }
        `,
        formInputWrapper: css`
            flex: 1;
        `,
        inputSelect: css`
            border: 2px solid ${getColor("common.border")};
            border-radius: 3px;
            background-color: ${getColor("common.white")};
            box-sizing: border-box;
            height: 38px;
            padding-right: 26px;
            ${ellipsis(1, 38)}

            // To hide select arror from IE browser
            &::-ms-expand {
                display: none;
            }

            &:focus {
                padding-right: 25px;
                padding-left: 10px;
            }
        `,
    },
};

sortSelectStyles.select = {
    ...plpSelectStyle,
};
